var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 191,
    viewBox: "0 0 184 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1319_1122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.0771 62C92.0749 62.2194 93.1002 62.3563 94.0687 62.674C99.8125 64.5521 103.65 70.3179 103.182 76.2997C102.683 82.6675 98.1908 87.7067 92.1162 88.7125C84.6164 89.9534 77.6457 84.5052 76.8737 76.7946C76.1395 69.4737 81.387 62.8653 88.549 62.0878C88.6765 62.0737 88.8006 62.0298 88.9264 62C89.6433 62 90.3602 62 91.0771 62Z",
    fill: "url(#paint0_linear_1319_1122)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0035 112.999C83.2585 112.999 76.5135 112.999 69.7668 112.999C68.5312 112.999 67.9832 112.431 68.0004 111.169C68.1245 101.717 74.978 93.6288 84.1701 92.1123C85.0024 91.9754 85.8538 91.9087 86.6982 91.8964C88.8161 91.8648 90.934 91.8648 93.052 91.8859C101.568 91.9701 109.068 97.8816 111.305 106.254C111.739 107.878 111.974 109.531 112 111.214C112.017 112.408 111.452 112.997 110.287 112.999C103.526 113.001 96.7639 112.999 90.0035 112.999Z",
    fill: "url(#paint1_linear_1319_1122)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1319_1122",
    x: 0,
    y: 0,
    width: 184,
    height: 191,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1319_1122"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1319_1122",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1319_1122",
    x1: 68,
    y1: 62,
    x2: 112.992,
    y2: 62.8911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6916AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E03D84"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1319_1122",
    x1: 68,
    y1: 62,
    x2: 112.992,
    y2: 62.8911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6916AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E03D84"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector6);
export default __webpack_public_path__ + "static/media/Vector  6 .d9fdb20ff993dd2b7d8a8c5fd4e7caf9.svg";
export { ForwardRef as ReactComponent };